// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/splashBG.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.splash-container {
  height: 100vh;
  width: 100vw !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  overflow: visible;
  background-repeat: no-repeat;
  background-size: cover; }
  @media (max-width: 1000px) {
    .splash-container #hucSplash_ .splash-text {
      line-height: 14px !important; }
    .splash-container .splash-text {
      font-size: 14px !important; }
    .splash-container .splash-heading {
      font-size: 14px !important; }
      .splash-container .splash-heading h4 {
        margin-top: 1rem !important;
        font-size: 14px !important; }
    .splash-container .splash-btn {
      font-size: 14px !important; } }
  .splash-container .splash-banner {
    width: -webkit-fill-available;
    min-width: 659px; }
  .splash-container #hucSplash {
    border-radius: 30px 0px 0px 0px;
    height: 35vh;
    min-height: 170px; }
  .splash-container #hucSplash_ .splash-text {
    line-height: 1.2cqw; }
  .splash-container .splash-logout {
    position: absolute;
    top: 0;
    right: 1vw;
    background-color: unset;
    height: 100%;
    width: 4vw;
    display: inline-flex;
    align-items: center;
    font-size: 1.2cqw;
    justify-items: center; }
  .splash-container .sheen {
    top: auto;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: -webkit-fill-available;
    background: #011d3fd4; }
  .splash-container .splash-top {
    height: 19vh !important; }
  .splash-container .splash-top h3 {
    position: relative;
    color: white;
    z-index: 10;
    font-size: 3cqw; }
    .splash-container .splash-top h3 img {
      height: 5vh;
      vertical-align: text-top; }
  .splash-container .splash-top h4 {
    position: relative;
    color: white;
    z-index: 10;
    font-size: 2cqw; }
  .splash-container .splash-top p {
    position: relative;
    color: white;
    z-index: 10; }
  .splash-container .splash-bottom {
    height: 50vh !important;
    margin-top: 0px; }
    .splash-container .splash-bottom .splash-img-container {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      align-items: center;
      position: relative; }
      .splash-container .splash-bottom .splash-img-container .splash-img {
        position: relative;
        top: 0;
        width: 100%; }
      .splash-container .splash-bottom .splash-img-container .splash-text-box {
        position: relative;
        width: 100%;
        height: -webkit-fill-available;
        display: flex;
        background-color: white;
        border-bottom-right-radius: 3vw 3vw;
        align-items: center;
        flex-direction: column; }
        .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-heading {
          text-align: center;
          position: relative;
          z-index: 10;
          font-size: 1.2cqw;
          color: #0b1736; }
          .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-heading h4 {
            margin-top: 1rem;
            font-size: 1.2cqw;
            font-weight: bold;
            flex-direction: row;
            display: flex;
            align-items: center; }
            .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-heading h4 img {
              height: 2vh;
              margin-right: 2px; }
        .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-text {
          text-align: center;
          font-size: 1.17cqw; }
          .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-text p {
            padding-left: 10px;
            padding-right: 8px; }
        .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-btn {
          background: #002046;
          border-radius: 1vh;
          font-size: 1.2cqw;
          color: white;
          width: 14vw;
          min-width: 140px;
          height: 5vh;
          position: absolute;
          bottom: 5%; }
          .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-btn img {
            margin-left: 4px; }
          .splash-container .splash-bottom .splash-img-container .splash-text-box .splash-btn:hover {
            background: #0a58ca; }
        .splash-container .splash-bottom .splash-img-container .splash-text-box h2 {
          color: white;
          text-shadow: 1px 1px 2px #2a303a88;
          text-align: center;
          cursor: pointer; }
  .splash-container .splash-img-container {
    position: relative;
    z-index: 10;
    background-size: contain;
    background-position: center;
    border-top-left-radius: 2vw 2vw;
    border-bottom-right-radius: 3vw 3vw;
    padding-right: 0px;
    padding-left: 0px;
    width: 22vw;
    aspect-ratio: 0.62;
    min-width: 240px;
    min-height: 400px;
    border: 2px solid #2f528f;
    cursor: pointer;
    margin-bottom: 12px; }
    .splash-container .splash-img-container:hover {
      border: 3px solid #0a58ca; }
      .splash-container .splash-img-container:hover .splash-heading h4 {
        text-decoration: underline; }
    .splash-container .splash-img-container .disabled {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #8080807a;
      position: absolute;
      border-top-left-radius: 2vw 2vw;
      border-bottom-right-radius: 3vw 3vw;
      z-index: 10; }
    .splash-container .splash-img-container .splash-modal {
      position: absolute;
      z-index: 15;
      background: #0b1736;
      text-align: center;
      font-size: 1.2cqw;
      width: 80%;
      color: white;
      margin-bottom: 0;
      border-radius: 4px;
      padding: 2vw; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .login .swish {
    right: -65%; }
  .login .input-wrapper input {
    width: 350px !important; }
  .login .login-btn-box .login-button {
    width: 350px;
    height: 60px !important;
    border-radius: 10px !important; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/layout/Splash/splash.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACE,aAAa;EACb,uBAAuB;EACvB,yDAAgD;EAChD,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB,EAAA;EAGtB;IATF;MAYQ,4BAA4B,EAAA;IAZpC;MAiBM,0BAA0B,EAAA;IAjBhC;MAqBQ,0BAA0B,EAAA;MArBlC;QAuBU,2BAA2B;QAC3B,0BAA0B,EAAA;IAxBpC;MA6BQ,0BAA0B,EAAA,EAC5B;EA9BN;IAkCI,6BAA6B;IAC7B,gBAAgB,EAAA;EAnCpB;IAuCI,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB,EAAA;EAzCrB;IA8CQ,mBAAmB,EAAA;EA9C3B;IAoDI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB,EAAA;EA7DzB;IAiEI,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,qBAAqB,EAAA;EAtEzB;IA0EI,uBAAuB,EAAA;EA1E3B;IA+EM,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe,EAAA;IAlFrB;MAqFQ,WAAW;MACX,wBAAwB,EAAA;EAtFhC;IA2FM,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe,EAAA;EA9FrB;IAkGM,kBAAkB;IAClB,YAAY;IACZ,WAAW,EAAA;EApGjB;IA0GI,uBAAuB;IACvB,eAAe,EAAA;IA3GnB;MA8GM,aAAa;MACb,sBAAsB;MACtB,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB,EAAA;MAlHxB;QAoHQ,kBAAkB;QAClB,MAAM;QACN,WAAW,EAAA;MAtHnB;QA0HQ,kBAAkB;QAClB,WAAW;QACX,8BAA8B;QAC9B,aAAa;QACb,uBAAuB;QACvB,mCAAmC;QACnC,mBAAmB;QACnB,sBAAsB,EAAA;QAjI9B;UAmIU,kBAAkB;UAClB,kBAAkB;UAClB,WAAW;UACX,iBAAiB;UACjB,cAAc,EAAA;UAvIxB;YAyIY,gBAAgB;YAChB,iBAAiB;YACjB,iBAAiB;YACjB,mBAAmB;YACnB,aAAa;YACb,mBAAmB,EAAA;YA9I/B;cAiJc,WAAW;cACX,iBAAiB,EAAA;QAlJ/B;UAuJU,kBAAkB;UAClB,kBAAkB,EAAA;UAxJ5B;YA2JY,kBAAkB;YAClB,kBAAkB,EAAA;QA5J9B;UAgKU,mBAAmB;UACnB,kBAAkB;UAClB,iBAAiB;UACjB,YAAY;UACZ,WAAW;UACX,gBAAgB;UAChB,WAAW;UACX,kBAAkB;UAClB,UAAU,EAAA;UAxKpB;YA0KY,gBAAgB,EAAA;UA1K5B;YA8KY,mBAA4B,EAAA;QA9KxC;UAkLU,YAAY;UACZ,kCAAkC;UAClC,kBAAkB;UAClB,eAAe,EAAA;EArLzB;IA4LI,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,2BAA2B;IAC3B,+BAA+B;IAC/B,mCAAmC;IACnC,kBAAkB;IAClB,iBAAiB;IAEjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IAEjB,yBAAyB;IACzB,eAAe;IACf,mBAAmB,EAAA;IA5MvB;MA+MM,yBAAkC,EAAA;MA/MxC;QAmNc,0BAA0B,EAAA;IAnNxC;MAyNM,cAAc;MACd,WAAW;MACX,YAAY;MACZ,2BAA2B;MAC3B,kBAAkB;MAClB,+BAAgC;MAChC,mCAAmC;MACnC,WAAW,EAAA;IAhOjB;MAoOM,kBAAkB;MAClB,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,iBAAiB;MACjB,UAAU;MACV,YAAY;MACZ,gBAAgB;MAChB,kBAAkB;MAClB,YAAY,EAAA;;AAKlB;EACE;IAEI,WAAW,EAAA;EAFf;IAOM,uBAAuB,EAAA;EAP7B;IAaM,YAAY;IACZ,uBAAuB;IACvB,8BAA8B,EAAA,EAC/B","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import '../../theme/_variables.scss';\n\n.splash-container {\n  height: 100vh;\n  width: 100vw !important;\n  background-image: url(../../assets/splashBG.png);\n  overflow: visible;\n  background-repeat: no-repeat;\n  background-size: cover;\n\n\n  @media (max-width: 1000px) {\n    #hucSplash_ {\n      .splash-text {\n        line-height: 14px !important;\n      }\n    }   \n\n    .splash-text {\n      font-size: 14px !important;\n    }\n\n    .splash-heading {\n        font-size: 14px !important;\n        h4 {\n          margin-top: 1rem !important;\n          font-size: 14px !important;\n        }\n    }\n\n    .splash-btn {\n        font-size: 14px !important;\n     }     \n  }\n\n  .splash-banner {\n    width: -webkit-fill-available;\n    min-width: 659px;\n  }\n\n  #hucSplash {\n    border-radius: 30px 0px 0px 0px;\n    height: 35vh;\n    min-height: 170px;\n  }\n\n  #hucSplash_ {\n      .splash-text {\n        line-height: 1.2cqw;\n      }\n  }\n\n  .splash-logout {\n    \n    position: absolute;\n    top: 0;\n    right: 1vw;\n    background-color: unset;\n    height: 100%;\n    width: 4vw;\n    display: inline-flex;\n    align-items: center;\n    font-size: 1.2cqw;\n    justify-items: center;\n  }\n\n  .sheen {\n    top: auto;\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    height: -webkit-fill-available;\n    background: #011d3fd4;\n  }\n\n  .splash-top {\n    height: 19vh !important;\n  }\n\n  .splash-top {\n    h3 {\n      position: relative;\n      color: white;\n      z-index: 10;\n      font-size: 3cqw;\n\n      img {\n        height: 5vh;\n        vertical-align: text-top;\n      }\n    }\n\n    h4 {\n      position: relative;\n      color: white;\n      z-index: 10;\n      font-size: 2cqw;      \n    }\n\n    p {\n      position: relative;\n      color: white;\n      z-index: 10;\n    }\n  }\n\n\n  .splash-bottom {\n    height: 50vh !important;\n    margin-top: 0px;\n    .splash-img-container {\n\n      display: flex;\n      flex-direction: column;\n      margin-left: 10px;\n      align-items: center;\n      position: relative;\n      .splash-img {\n        position: relative;\n        top: 0;\n        width: 100%;\n      }\n\n      .splash-text-box {\n        position: relative;\n        width: 100%;\n        height: -webkit-fill-available;\n        display: flex;\n        background-color: white; \n        border-bottom-right-radius: 3vw 3vw;\n        align-items: center;\n        flex-direction: column;\n        .splash-heading {\n          text-align: center;\n          position: relative;\n          z-index: 10;\n          font-size: 1.2cqw;\n          color: #0b1736;\n          h4 {\n            margin-top: 1rem;\n            font-size: 1.2cqw;\n            font-weight: bold;\n            flex-direction: row;\n            display: flex;\n            align-items: center;\n            \n            img {\n              height: 2vh;\n              margin-right: 2px;\n            }\n          }\n        }\n        .splash-text {\n          text-align: center;\n          font-size: 1.17cqw;\n\n          p {\n            padding-left: 10px;\n            padding-right: 8px;\n          }\n        }\n        .splash-btn {\n          background: #002046;\n          border-radius: 1vh;\n          font-size: 1.2cqw;\n          color: white;\n          width: 14vw;\n          min-width: 140px;\n          height: 5vh;\n          position: absolute;\n          bottom: 5%;\n          img {\n            margin-left: 4px;\n          }\n\n          &:hover {\n            background: rgb(10, 88, 202);\n          }\n        }\n        h2 {\n          color: white;\n          text-shadow: 1px 1px 2px #2a303a88;\n          text-align: center;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  .splash-img-container {\n    position: relative;\n    z-index: 10;\n    background-size: contain;\n    background-position: center;\n    border-top-left-radius: 2vw 2vw;\n    border-bottom-right-radius: 3vw 3vw;\n    padding-right: 0px;\n    padding-left: 0px;\n \n    width: 22vw;\n    aspect-ratio: 0.62;  \n    min-width: 240px;\n    min-height: 400px;\n    \n    border: 2px solid #2f528f;\n    cursor: pointer;\n    margin-bottom: 12px;\n\n    &:hover {\n      border: 3px solid rgb(10, 88, 202);\n\n      .splash-heading {\n          h4 {\n              text-decoration: underline;\n          }\n      }\n    }\n\n    .disabled {\n      display: block;\n      width: 100%;\n      height: 100%;\n      background-color: #8080807a;\n      position: absolute;\n      border-top-left-radius:  2vw 2vw;\n      border-bottom-right-radius: 3vw 3vw;\n      z-index: 10;\n    }\n\n    .splash-modal {\n      position: absolute;\n      z-index: 15;\n      background: #0b1736;\n      text-align: center;\n      font-size: 1.2cqw;\n      width: 80%;\n      color: white;\n      margin-bottom: 0;\n      border-radius: 4px;\n      padding: 2vw;\n    }\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n  .login {\n    .swish {\n      right: -65%;\n    }\n\n    .input-wrapper {\n      input {\n        width: 350px !important;\n      }\n    }\n\n    .login-btn-box {\n      .login-button {\n        width: 350px;\n        height: 60px !important;\n        border-radius: 10px !important;\n      }\n    }\n  }\n}\n\n// @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n//   .login .swish {\n//     right: -20% !important;\n//   }\n\n//   .login .login-btn-box .login-button {\n//     width: 350px;\n//     height: 60px !important;\n//     border-radius: 10px !important;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
